import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { Button } from "@mui/material";


type Props = {
    onActionExportar: (idContaReceber: number) => void,
}

export const GenerateContasReceberDeletadasColumns = ({
    onActionExportar,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Em Aberto"; // EM ABERTO
            case 1: // PAGO
                return "Recebida";
            case 2: // OUTROS
                return "Outros";
            case 3: // ATRASADAS
                return "Atrasada";
            case 4: // RECEBIMENTO PARCIAL
                return "Parcial";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "gray"; // em aberto
            case 1: // PAGO
                return "green";
            case 2: // OUTROS
                return "yellow";
            case 3: // ATRASADA
                return "red";
            case 4: // RECEBIMENTO PARCIAL
                return "blue";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "Conta em aberto";
            case 1: // PAGO
                return "Conta recebida";
            case 2: // OUTROS
                return "Outros";
            case 3: // EM ABERTO
                return "Conta atrasada";
            case 4: // RECEBIMENTO PARCIAL
                return "Recebimento Parcial";
            default:
                return "?";
        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "nrContasReceber",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "nrParcela",
            filterable: false,
            headerName: "N° Parcela",
            flex: 1,
            minWidth: 70,
            sortable: false,
        }, {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 150,
            sortable: false,
        }, {
            field: "nroOrdemCompra",
            filterable: false,
            headerName: "OC",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "nomeCliente",
            filterable: false,
            headerName: "Cliente",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nrContrato",
            filterable: false,
            headerName: "N° Contrato",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nomeSubConta",
            filterable: false,
            headerName: "Subconta",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nome",
            filterable: false,
            headerName: "Titulo",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "valorReceber",
            filterable: false,
            headerName: "Valor Receber",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataReceber",
            filterable: false,
            headerName: "Data Receber",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorBaixa",
            filterable: false,
            headerName: "Valor Recebido",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataBaixa",
            filterable: false,
            headerName: "Data Recebido",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "deletadaPor",
            filterable: false,
            headerName: "Deletada Por",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "deletadaData",
            filterable: false,
            headerName: "Deletada Em",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            sortable: false,
            valueGetter: (_, row) => row['idContasReceber'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => onActionExportar(value)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },




    ];

}